import { render, staticRenderFns } from "./ProjectSiteUtilitiesDashboardDataNew.vue?vue&type=template&id=509c3deb"
import script from "./ProjectSiteUtilitiesDashboardDataNew.vue?vue&type=script&lang=js"
export * from "./ProjectSiteUtilitiesDashboardDataNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports